<div class="container-fluid m-0 p-0">
  <div class="blog-header-container">
    <h1 translate>ბლოგი</h1>
  </div>
</div>
<ng-container *ngIf="i18nService.language !== 'EN'">
  <div class="container blog-item ">
    <h1>ხელმისაწვდომი ხარისხი - მეორადი ავტომობილების პროდუქტი</h1>
    <h5 style="font-family: NUSXURI;text-align: left"></h5>
    <h6>მაისი 2021</h6>

    <p>
      რა არის შენთვის, როგორც მომხმარებლისთვის, მთავარი ღირებულება? ალბათ, ხარისხი. თუმცა, ხარისხი სასურველი ნივთისთვის
      განკუთვნილ ბიუჯეტს მომენტალურად ზრდის ხოლმე. მაშინ გაიხსენე მომენტი, როდესაც ძალიან ხარისხიანი ნივთი ხელმისაწვდომ
      ფასად შეიძინე, ასეთი შენაძენი ყოველთვის განსაკუთრებით გვახარებს ხოლმე, არა? ჰო, ხარისხი მნიშვნელოვანია, მაგრამ
      მასთან ერთად, სწორედ ხელმისაწვდომობაა ის კომპონენტი, რომელიც შეთავაზებას შენთვის უფრო მიმზიდველს და სასიხარულოს
      ხდის.
    </p>

    <p>
      თიბისი ლიზინგში ეგრედ წოდებული ხელმისაწვდომი ხარისხის სიხარული შეგიძლია მეორადი ავტომობილის შეძენით განიცადო.
    </p>

    <img src="../../../../assets/blog/used/img1.jpg" alt="" />

    <p>
      ხშირად, მეორადი ავტომობილის ხსენებისას, გონებაში შედარებით გაცვეთილი და გაუმართავი მანქანის სურათხატი
      ამოტივტივდება ხოლმე, თუმცა თუ გავითვალისწინებთ, რომ თიბისი ლიზინგი დასაფინანსებლად მხოლოდ 2006 წლის ზემოთ,
      ტექდათვალიერება გავლილ ავტომობილებს განიხილავს, სურათი მომენტალურად შეიცვლება.
    </p>
    <p>
      მართლაც, ბუნებრივია, რომ ცენტრიდან გამოყვანილ ავტომობილს თავისი ხიბლი აქვს, მაგრამ შეთავაზება საუკეთესო მაშინაა,
      როდესაც ხელმისაწვდომ ფასად, მაქსიმალურ ხარისხს იღებ. ამ გამოცდილების მიღება კი, მეორადი ავტომობილის შერჩევისას
      შეგიძლია.
    </p>
    <p>
      დღეს ბლოგში მეორად ავტომობილებზე ვისაუბრებთ და იმისთვის, რომ საქმე გაგიმარტივოთ, გამოვყოფთ პუნქტებს, რომლებიც
      მომხმარებლებს ყველაზე მეტად აინტერესებთ.
    </p>
    <img src="../../../../assets/blog/used/img2.jpg" alt="" />
    <p>
      გარდა იმისა, რომ შენთვის სასურველი ნებისმიერი მოდელის შეძენა გაცილებით იაფდება, ისიც აღსანიშნავია, რომ მეორადი
      ავტომობილების სიაში ბოლო დროს გამოშვებული უახლესი მოდელებიც შედიან. გამოდის, რომ თანამედროვე დიზაინსა და
      ტექნოლოგიას, მოდელის რეალურ ღირებულებასთან შედარებით, დაბალ ფასად მიიღებ. თანაც, თავისთავად, ლიზინგის ყოველთვიური
      გადასახადიც შენთვის გაცილებით მისაღები თანხა იქნება.
    </p>
    <p>
      მეორადი ავტომობილების ლიზინგის ერთ-ერთი მთავარი უპირატესობები სწორედ, ნაკლები ყოველთვიური გადასახადი, ფასთან
      მიმართებით მაღალი ხარისხი და მარტივი დამტკიცების პროცესია.
    </p>

    <div style="max-width: 800px; margin: auto;">
      <div class="row" style="padding-top: 50px;padding-bottom: 50px;">
        <div class="col-4">
          <h5 style="color: #2748bf;font-weight: bold;">ნაკლები ყოველთვიური გადასახადი</h5>
        </div>
        <div class="col-4">
          <h5 style="color: #14e2bc;font-weight: bold;">ფასთან მიმართებით მაღალი ხარისხი</h5>
        </div>
        <div class="col-4">
          <h5 style="color: #bca0ff;font-weight: bold;">მარტივი დამტკიცების პროცესი</h5>
        </div>
      </div>
    </div>

    <h4 class="h4blue">ლიზინგის ზოგადი პირობები მეორად ავტომობილებზე</h4>
    <p>
      ლიზინგის დახმარებით მეორადი ავტომობილის შეძენა სხვა ფინანსურ ინსტრუმენტებთან შედარებით მარტივია. დაფინანსების
      მისაღებად არ გჭირდება დამატებითი უზრუნველყოფა, რადგან ავტომობილი თავად ხდება უზრუნველყოფის საგანი.
    </p>
    <p>
      დამტკიცება საკრედიტო ისტორიიდან გამომდინარე ხდება, ინდივიდუალურად მორგებული პირობებით, შემოსავლების დეტალური
      შესწავლის გარეშე.
    </p>
    <p>
      ლიზინგის დაფარვა 3 თვეშიც შეგიძლია და 5 წელიწადშიც, მთავარია 21-65 წლამდე იყო და საკრედიტო ისტორია მოწესრიგებული
      გქონდეს.
    </p>
    <img src="../../../../assets/blog/used/img3.jpg" alt="" />
    <h4 class="h4blue">თვეში რამდენის გადახდა მომიწევს</h4>
    <p>
      ყოველთვიური გადასახადის უნივერსალური სია არ არსებობს, ეს დამოკიდებულია შენზე და შენ მიერ არჩეულ პირობებზე, თუმცა,
      ბევრს ყველაზე მეტად სწორედ ეს აინტერესებს, ამიტომ საორიენტაციოდ რამდენიმე მაგალითს გაგიზიარებთ.
    </p>
    <p>
      მინიმალური თანამონაწილეობა, რომელიც ავტომობილის ლიზინგით შეძენისას უნდა განახორციელო 10%-ია, რაც ნიშნავს, რომ თუ
      მაგალითად, შენთვის სასურველი ავტომობილი 10,000 ლარი ღირს, დასაწყისისთვის მოგიწევს 1000 ლარის შემოტანა, დანარჩენს
      კი, ყოველთვიურ გადასახადში, შეთანხმებულ ვადაზე გადაგინაწილებთ. თანამონაწილეობის თანხაც, ასევე დამოკიდებულია შენს
      საკრედიტო ისტორიაზე.
    </p>
    <p>
      თუ ჩავთვლით, რომ 10%-იანი თანამონაწილეობით შემოხვალ და ლიზინგის გადასახადს 5 წელიწადზე გადაანაწილებ, დაახლოებით
      ასეთ სურათს მივიღებთ:
    </p>

    <table class="pmttable">
      <thead>
        <th><h4 class="h4blue">ლიზინგის თანხა</h4></th>
        <th><h4 class="h4blue">ყოველთვიური გადასახადი</h4></th>
      </thead>
      <tr>
        <td>5000 ლარი</td>
        <td>185 ლარიდან</td>
      </tr>

      <tr>
        <td>8,000 ლარი</td>
        <td>260 ლარიდან</td>
      </tr>

      <tr>
        <td>10,000 ლარი</td>
        <td>320 ლარიდან</td>
      </tr>

      <tr>
        <td>15,000 ლარი</td>
        <td>475 ლარიდან</td>
      </tr>

      <tr>
        <td>20,000 ლარი</td>
        <td>640 ლარიდან</td>
      </tr>

      <tr>
        <td>25,000 ლარი</td>
        <td>780 ლარიდან</td>
      </tr>
      <tr>
        <td>30,000 ლარი</td>
        <td>945 ლარიდან</td>
      </tr>
    </table>

    <img src="../../../../assets/blog/used/img4.jpg" alt="" />
    <h4 class="h4blue">შეძენის პროცესი</h4>
    <p>
      თუ მეორადი ავტომობილის შეძენა ლიზინგით გადაწყვიტე, უნდა შეავსო განაცხადი და დამტკიცებული პირობების შესახებ იმავე
      დღესვე შეიტყობ. ამის შემდეგ, საჭიროა არჩეული ავტომობილი ჩვენთან მოიყვანო, რათა მოხდეს ავტომობილის ფასის
      განსაზღვრა, ანუ, შეფასება. საბოლოოდ, თუ პირობებზე თანახმა ხარ, ავტომობილი შენია.
    </p>
    <h4 class="h4blue">როგორი უნდა იყოს მეორადი ავტომობილი, რომლის დალიზინგებაც შეიძლება</h4>
    <p>
      წესები მარტივია, ლიზინგის დაფინანსების მისაღებად აუცილებელი პირობაა — ავტომობილი 2006 წელს ზემოთ იყოს და გავლილი
      ჰქონდეს ტექდათვალიერება, რაც ვფიქრობთ, შენთვისაც აუცილებელი მოთხოვნა უნდა იყოს, თუ გსურს, რომ ავტომობილმა კომფორტი
      შეგიქმნას და არა დამატებითი საზრუნავი.
    </p>
    <h4 class="h4blue">როგორ უმარტივებს ეს პროდუქტი მომხმარებელს ცხოვრებას?</h4>
    <p>
      მეორადი ავტომობილის ლიზინგი უმარტივებს ცხოვრებას იმ ადამიანებს, რომლებსაც ავტომობილის ღირებულების ერთიანად გადახდა
      არ შეუძლიათ და ყოველთვიურადაც დიდ თანხას ვერ გასწვდებიან. ეს პროდუქტი არის მოქნილი ინსტრუმენტი იმისთვის, რომ
      გყავდეს მანქანა მაშინაც კი, როცა ეს წარმოუდგენლადაც გეჩვენება. ეს პროდუქტი გაძლევს საშუალებას მიიღო ხარისხი
      ხელმისაწვდომ ფასად და კომფორტი ავტომობილის სახით.
    </p>

    <div class="blog-author"><span>ავტორი: ნინჩო ბალანჩივაძე</span></div>
  </div>
</ng-container>

<ng-container *ngIf="i18nService.language === 'EN'">
  <div class="container blog-item ">
    <h1>Accessible Quality - Used Car Product</h1>
    <h5 style="font-family: NUSXURI;text-align: left"></h5>
    <h6>May 2021</h6>

    <p>
      What is the main value for you as a customer? Probably, it's quality. However, quality often increases the budget
      for the desired item almost instantly. Now, recall a moment when you bought something of very high quality at an
      affordable price — that kind of purchase always brings special joy, right? Yes, quality is important, but
      alongside it, accessibility is the component that makes an offer more attractive and delightful.
    </p>

    <p>
      At TBC Leasing, you can experience the joy of accessible quality through the purchase of a used car.
    </p>

    <img src="../../../../assets/blog/used/img1.jpg" alt="" />

    <p>
      When we mention used cars, we often picture a worn-out and unreliable vehicle. However, when you consider that TBC
      Leasing only accepts cars from 2006 and newer, that have passed technical inspection, the image changes instantly.
    </p>
    <p>
      Of course, a car that’s just come off the factory floor has its charm, but the offer is best when you get maximum
      quality at an affordable price. And this experience can be had when selecting a used car.
    </p>
    <p>
      In today’s blog, we will talk about used cars, and to make things easier for you, we’ll highlight the points that
      most interest customers.
    </p>
    <img src="../../../../assets/blog/used/img2.jpg" alt="" />

    <p>
      Aside from the fact that any model you wish to purchase becomes significantly more affordable, it's also worth
      mentioning that the list of used cars includes the newest models released recently. This means you get modern
      design and technology at a lower price compared to the real value of the model. Additionally, the monthly leasing
      payments will also be much more manageable for you.
    </p>
    <p>
      One of the main advantages of used car leasing is lower monthly payments, higher quality for the price, and a
      simple approval process.
    </p>

    <div style="max-width: 800px; margin: auto;">
      <div class="row" style="padding-top: 50px;padding-bottom: 50px;">
        <div class="col-4">
          <h5 style="color: #2748bf;font-weight: bold;">lower monthly payments</h5>
        </div>
        <div class="col-4">
          <h5 style="color: #14e2bc;font-weight: bold;">higher quality of the price</h5>
        </div>
        <div class="col-4">
          <h5 style="color: #bca0ff;font-weight: bold;">simple approval process</h5>
        </div>
      </div>
    </div>

    <h4 class="h4blue">Leasing Terms for Used Cars</h4>
    <p>
      Leasing a used car is easier compared to other financial instruments. You don't need additional collateral because
      the car itself serves as collateral.
    </p>
    <p>
      Approval is based on your credit history, with terms tailored to you, and without the need for a detailed income
      review.
    </p>
    <p>
      You can pay for the leasing over 3 months to 5 years, as long as you are between 21-65 years old and have a good
      credit history.
    </p>
    <img src="../../../../assets/blog/used/img3.jpg" alt="" />
    <h4 class="h4blue">How Much Will I Have to Pay Each Month?</h4>
    <p>
      There is no universal amount for monthly payments. It depends on you and the terms you choose, but many people are
      most interested in this, so I will share a few examples to guide you.
    </p>
    <p>
      The minimum down payment for purchasing a car via leasing is 10%, which means that if, for example, the car you
      want costs 10,000 GEL, you will need to pay 1,000 GEL upfront. The rest will be spread across your monthly
      payments. The down payment amount also depends on your credit history.
    </p>
    <p>
      Let’s assume you make a 10% down payment and choose to spread the payments over 5 years. Here's an example of the
      monthly payment amounts for different lease amounts:
    </p>

    <table class="pmttable">
      <thead>
        <th><h4 class="h4blue">Leasing Amount</h4></th>
        <th><h4 class="h4blue">Monthly Payment (approx.)</h4></th>
      </thead>
      <tr>
        <td>5000 GEL</td>
        <td>From 185 GEL</td>
      </tr>

      <tr>
        <td>8,000 GEL</td>
        <td>From 260 GEL</td>
      </tr>

      <tr>
        <td>10,000 GEL</td>
        <td>From 320 GEL</td>
      </tr>

      <tr>
        <td>15,000 GEL</td>
        <td>From 475 GEL</td>
      </tr>

      <tr>
        <td>20,000 GEL</td>
        <td>From 640 GEL</td>
      </tr>

      <tr>
        <td>25,000 GEL</td>
        <td>From 780 GEL</td>
      </tr>
      <tr>
        <td>30,000 GEL</td>
        <td>From 945 GEL</td>
      </tr>
    </table>

    <img src="../../../../assets/blog/used/img4.jpg" alt="" />
    <h4 class="h4blue">The Purchase Process</h4>
    <p>
      If you decide to buy a used car through leasing, you need to fill out an application, and you’ll know the approved
      terms the same day. After that, you need to bring the selected car to us for an evaluation. The car's price will
      be determined, and if you agree to the terms, the car is yours.
    </p>
    <h4 class="h4blue">Requirements for a Used Car to Be Eligible for Leasing</h4>
    <p>
      The rules are simple: to qualify for leasing, the car must be from 2006 or newer and must have passed technical
      inspection. This, of course, should be an essential requirement if you want the car to offer comfort, not
      additional concerns.
    </p>
    <h4 class="h4blue">How Does This Product Simplify Life for Customers?</h4>
    <p>
      Used car leasing makes life easier for those who can’t pay the full value of the car upfront and can’t afford
      large monthly payments. This product is a flexible tool to help you own a car even when it seems out of reach. It
      gives you the opportunity to get high quality at an affordable price and the comfort of a car.
    </p>

    <div class="blog-author"><span>Author: Nincho Balanchivadze</span></div>
  </div>
</ng-container>
